import React, { useState } from 'react';
import { Card, Button } from "tabler-react";

const StoriesCard = ({ story: { _id, body, cityId, countryId, photo, title }, openMainModal, reload }) => {
  const [showFullBody, setShowFullBody] = useState(false)

  return (
    <Card>
      <Card.Body>
        <img style={{ margin: 'auto', display: 'block' }}
          alt="Cover"
          src={photo}
          width="220"
          height="120"
        />
      </Card.Body>
      <Card.Footer>
        <div>
          <h3>{title}</h3>
          <h4>{countryId.name}, {cityId.name}</h4>
          <p>
            {showFullBody ? body : body.substring(0, 50)}

            {body.length > 50 &&
              <span onClick={() => setShowFullBody(s => !s)}
                style={{ textDecoration: 'underline', color: 'blue', fontSize: '14px', cursor: 'pointer', display: 'block' }}>
                {showFullBody ? 'Read Less' : 'Read More'}
              </span>
            }
          </p>

          <div>
          <Button
              outline
              color="primary"
              size="sm"
              onClick={()=> openMainModal('story-edit', _id, reload)}
            >
              Edit
            </Button>
            <Button
              outline
              color="danger"
              size="sm"
              className="ml-2"
              onClick={() => openMainModal('stories--delete', _id, reload)}
            >
              Delete
            </Button>
          </div>
        </div>
      </Card.Footer>
    </Card>
  );
}
export default StoriesCard;